const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const MONTHS_FULL = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];

import moment from 'moment'

export const dayPossibleInMonth = (day, month, year) => {
  if (!day || !month || !year) return false

  var m = MONTHS_FULL.indexOf(month.toLowerCase()) + 1
  if (m < 1) return false

  var daysInMonth = moment(year + "-" + m, "YYYY-MM").daysInMonth()
  if (day < 1 || day > daysInMonth) return false

  return true
}

export const format_fullMonth_from_ISOShort = (dateAsIsoShort) => {
  if(!dateAsIsoShort) return dateAsIsoShort
  var d = dateAsIsoShort.split("-")
  return MONTHS_FULL[d[1] - 1]
}


// e.g: dateAsIsoShort = 1991-8-16 --> 16 Aug 1991
export const formatISOShortToDDMonthYYYY = (dateAsIsoShort) => {
  var d = dateAsIsoShort.split("-")
  var res = ""
  res += d[2] + " "
  res += MONTHS[d[1] - 1] + " "
  res += d[0]
  return res
}

export const formatISOShortToDDMonth = (dateAsIsoShort) => {
  var d = dateAsIsoShort.split("-")
  var res = ""
  res += d[2] + " "
  res += MONTHS_FULL[d[1] - 1]
  return res
}

export const formatDateToString = (date, format) => {
  return moment(date).format(format);
}

export const MM2Month = (monthInNumber) => {
  return capitalize(MONTHS_FULL[monthInNumber - 1]);
}

function capitalize(value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export let getTimeDifference = (periodStart, periodEnd) => {
  let years, months, totalNrOfDays;
  let totalDaysInPreMonth, nrOfDaysInPreMonth, totalDaysInPostMonth, nrOfDaysInPostMonth

  var inDate = moment(periodStart);
  totalDaysInPreMonth = inDate.daysInMonth();
  if (inDate.date() == 1) nrOfDaysInPreMonth = 0
  else nrOfDaysInPreMonth = totalDaysInPreMonth - inDate.date() + 1
 
  if(periodEnd){
    var outDate = moment(periodEnd);
    totalDaysInPostMonth = outDate.daysInMonth();
    nrOfDaysInPostMonth = outDate.date() - 1   
    years = outDate.diff(inDate, 'year');
    totalNrOfDays = outDate.diff(inDate, 'days');
    months = (outDate.subtract(nrOfDaysInPostMonth, 'days')).diff(inDate.add(nrOfDaysInPreMonth, 'days'), 'months');
  }

  var diff = {
      months: months,
      preDays: { nrOfDaysStaying: nrOfDaysInPreMonth, daysInMonth: totalDaysInPreMonth },
      postDays: { nrOfDaysStaying: nrOfDaysInPostMonth, daysInMonth: totalDaysInPostMonth },
      years: years,
      totalNrOfDays: totalNrOfDays,
  }
  return diff
}


// If today, return time, else return day (short)
// if fail return ''
export let calculateDiffOfDays = function (periodStart, periodEnd) {
  var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
  return Math.round(Math.abs((periodStart.getTime() - periodEnd.getTime()) / (oneDay)));
}

export let removeTimezoneReturnAsString = function (date) {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())).toISOString()
}

export let getPriceTier = function (periodStart, periodEnd) {
  if (periodStart && periodEnd) {
    var daysDiff = calculateDiffOfDays(new Date(periodStart), new Date(periodEnd))
    if (daysDiff < 30) return "daily"
  }
  return "monthly"
}

// If today, return time, else return day (short)
// if fail return ''
export let formatToDynamicTime = function (isoDateString) {
  try {
    var t = new Date();
    var md = new Date(isoDateString)
    // if today
    if (md.getDate() == t.getDate() && md.getMonth() == t.getMonth() && md.getFullYear() == t.getFullYear()) {
      let minutes
      md.getMinutes() < 10 ? minutes = '0' + md.getMinutes() : minutes = md.getMinutes()
      return md.getHours() + ':' + minutes
    } else {
      return DAYS[md.getDay()]
    }
  } catch (err) {
    return ''
  }
}

export let formatTimeToMonthDDYY = function (isoDateString) {
  try {
    if (!isoDateString) return ""
    var md = new Date(isoDateString)
    return md.getDate() + ' ' + MONTHS[md.getMonth()] + ' ' + md.getFullYear()
  } catch (err) {
    return ''
  }
}

export let formatTimeToMonDD = function (isoDateString) {
  try {
    var md = new Date(isoDateString)
    return MONTHS[md.getMonth()] + ' ' + md.getDate()
  } catch (err) {
    return ''
  }
}

export let formatTimeToDDMMYYFromString = function (isoDateString) {
  try {
    if (!isoDateString) return ""
    var md = new Date(isoDateString)
    return md.getDate() + ' ' + MONTHS[md.getMonth()] + ' ' + md.getFullYear()
  } catch (err) {
    return ''
  }
}

export let formatTimeToDDMMYY = function (date) {
  try {
    let dateF
    date.getDate() < 10 ? dateF = '0' + date.getDate() : dateF = date.getDate()

    let month
    date.getMonth() < 10 ? month = '0' + date.getMonth() : month = date.getMonth()

    return dateF + "." + month + "." + date.getFullYear()
  } catch (err) {
    return ''
  }
}



// WEBPACK FOOTER //
// ./src/timeFunctions.js